// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
  max-width: 1800px;
  width: 100%;
  margin: 0 auto;
  padding: 24px;
  animation: fadeInUp 0.5s ease;
}

.admin-header {
  margin-bottom: 24px;
}

.admin-header h2 {
  margin-bottom: 16px;
  color: var(--text);
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.admin-tabs {
  display: flex;
  gap: 4px;
  background: var(--bg-card);
  padding: 4px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  overflow-x: auto;
}

.tab-btn {
  flex: 1 1;
  min-width: 110px;
  padding: 10px 16px;
  background: none;
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-muted);
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.tab-btn:hover {
  color: var(--primary);
  background: var(--primary-ultralight);
}

.tab-btn.active {
  color: var(--primary);
  background: var(--primary-ultralight);
  font-weight: 600;
  box-shadow: var(--shadow-xs);
}

.tab-icon {
  font-size: 16px;
  transition: var(--transition);
}

.tab-btn:hover .tab-icon,
.tab-btn.active .tab-icon {
  transform: scale(1.1);
}

.tab-content {
  animation: fadeInUp 0.4s ease;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border);
}

.section-header h3 {
  color: var(--gray-900);
  font-size: 20px;
  font-weight: 700;
}

.filtros-rapidos {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.filtros-rapidos select {
  padding: 10px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  font-size: 14px;
  background: var(--white);
  transition: var(--transition);
  font-family: var(--font-sans);
  cursor: pointer;
}

.filtros-rapidos select:hover {
  border-color: var(--gray-400);
}

.filtros-rapidos select:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
  transform: translateY(-1px);
}

/* Filtros */
.filtros-container {
  background: var(--bg-card);
  padding: 24px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  margin-bottom: 24px;
  border: 1px solid var(--border);
}

.filtros-container h3 {
  margin-bottom: 20px;
  color: var(--gray-900);
  font-size: 18px;
  font-weight: 700;
}

.filtros-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.filtros-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

/* Por estado */
.por-estado {
  background: var(--bg-card);
  padding: 24px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  margin-bottom: 24px;
  border: 1px solid var(--border);
}

.por-estado h3 {
  margin-bottom: 20px;
  color: var(--gray-900);
  font-size: 18px;
  font-weight: 700;
}

.estados-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.estado-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: var(--gray-50);
  border-radius: var(--radius);
  transition: var(--transition);
  border: 1px solid transparent;
}

.estado-card:hover {
  background: var(--white);
  border-color: var(--border);
  transform: translateY(-2px);
  box-shadow: var(--shadow-sm);
}

.estado-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  animation: pulse 2s ease infinite;
}

.estado-label {
  flex: 1 1;
  font-size: 13px;
  color: var(--gray-700);
  font-weight: 500;
}

.estado-count {
  font-size: 22px;
  font-weight: 800;
  color: var(--primary);
}

/* Tabla container */
.tabla-container {
  background: var(--bg-card);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  border: 1px solid var(--border);
  transition: var(--transition);
}

.tabla-container:hover {
  box-shadow: var(--shadow-md);
}

.tabla-container h3 {
  margin: 0;
  padding: 16px 20px;
  color: var(--gray-800);
  font-size: 16px;
  font-weight: 600;
  border-bottom: 1px solid var(--border);
  background: var(--gray-50);
}

/* Acciones celda */
.acciones-celda {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Áreas Grid */
.areas-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.area-card {
  background: var(--bg-card);
  padding: 24px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  transition: var(--transition);
  border: 1px solid var(--border);
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.4s ease;
  animation-fill-mode: both;
}

.area-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--primary), var(--info));
  transition: var(--transition);
}

.area-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-4px);
  border-color: var(--gray-200);
}

.area-card:hover::before {
  height: 6px;
}

.area-card.inactiva {
  opacity: 0.6;
}

.area-card.inactiva::before {
  background: var(--gray-400);
}

.area-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.area-header h4 {
  margin: 0;
  color: var(--gray-900);
  font-size: 18px;
  font-weight: 700;
}

.area-desc {
  color: var(--text-muted);
  font-size: 14px;
  margin-bottom: 16px;
  line-height: 1.6;
}

.area-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}

.area-actions {
  display: flex;
  gap: 8px;
}

/* Configuración */
.config-container {
  background: var(--bg-card);
  padding: 28px;
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
}

.config-section {
  margin-bottom: 28px;
  padding-bottom: 28px;
  border-bottom: 1px solid var(--border);
}

.config-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.config-section h4 {
  margin-bottom: 20px;
  color: var(--gray-900);
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
}

.config-section .form-group label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-weight: 500;
}

.config-section input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--primary);
  transition: var(--transition);
}

.config-section input[type="time"],
.config-section input[type="number"],
.config-section input[type="text"],
.config-section textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  font-size: 14px;
  transition: var(--transition);
  background: var(--white);
  font-family: var(--font-sans);
}

.config-section input[type="time"]:hover,
.config-section input[type="number"]:hover,
.config-section input[type="text"]:hover,
.config-section textarea:hover {
  border-color: var(--gray-400);
}

.config-section input:focus,
.config-section textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
  transform: translateY(-1px);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid var(--border);
}

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(8px);
  animation: fadeIn 0.2s ease;
}

.modal-content {
  background: var(--bg-card);
  padding: 28px;
  border-radius: var(--radius-lg);
  width: 90%;
  max-width: 520px;
  box-shadow: var(--shadow-xl);
  max-height: 90vh;
  overflow-y: auto;
  animation: modalSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  border: 1px solid var(--border);
}

.modal-content.modal-lg {
  max-width: 720px;
}

.modal-content h3 {
  margin-bottom: 20px;
  color: var(--gray-900);
  font-size: 20px;
  font-weight: 700;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
}

/* Password button */
.btn-password {
  background: var(--purple-light);
  color: var(--purple);
  border: 1px solid var(--purple);
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 14px;
  transition: var(--transition);
}

.btn-password:hover {
  background: var(--purple);
  color: var(--white);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
}

/* Password modal */
.password-user-info {
  color: var(--text-muted);
  font-size: 14px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: var(--gray-50);
  border-radius: var(--radius);
  border: 1px solid var(--border);
}

/* Responsive */
@media (max-width: 768px) {
  .admin-header h2 {
    font-size: 24px;
  }

  .admin-tabs {
    flex-direction: column;
    gap: 4px;
  }

  .tab-btn {
    justify-content: flex-start;
    min-width: auto;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filtros-rapidos {
    width: 100%;
    flex-direction: column;
  }

  .filtros-rapidos select {
    width: 100%;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .areas-grid {
    grid-template-columns: 1fr;
  }

  .estados-grid {
    grid-template-columns: 1fr;
  }

  .acciones-celda {
    flex-direction: column;
  }

  .acciones-celda .btn-small {
    width: 100%;
    text-align: center;
  }
  
  .modal-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .modal-actions button {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .admin-header h2 {
    font-size: 20px;
  }

  .tab-btn {
    padding: 10px 14px;
    font-size: 13px;
  }

  .tab-icon {
    font-size: 16px;
  }

  .config-container {
    padding: 20px;
  }

  .modal-content {
    padding: 20px;
  }
}

/* Dark mode overrides for AdminDashboard */
[data-theme="dark"] .admin-header h2 {
  color: #ffffff;
}

[data-theme="dark"] .admin-tabs {
  background: var(--bg-card);
  border-color: var(--border);
}

[data-theme="dark"] .tab-btn {
  color: var(--text-muted);
}

[data-theme="dark"] .tab-btn:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.05);
}

[data-theme="dark"] .tab-btn.active {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: none;
}

[data-theme="dark"] .section-header h3,
[data-theme="dark"] .filtros-container h3,
[data-theme="dark"] .por-estado h3,
[data-theme="dark"] .area-header h4,
[data-theme="dark"] .config-section h4,
[data-theme="dark"] .modal-content h3 {
  color: #ffffff;
}

[data-theme="dark"] .estado-label {
  color: var(--text-secondary);
}

[data-theme="dark"] .estado-count {
  color: #60a5fa;
}

[data-theme="dark"] .estado-card {
  background: var(--bg-card);
  border-color: var(--border);
}

[data-theme="dark"] .estado-card:hover {
  background: var(--bg-subtle);
  border-color: var(--border);
  box-shadow: none;
}

[data-theme="dark"] .tabla-container h3 {
  color: #ffffff;
  background: var(--bg-subtle);
  border-color: var(--border);
}

[data-theme="dark"] .role-badge {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

[data-theme="dark"] .bandeja-entrada-titulo {
  color: #ffffff;
}

[data-theme="dark"] .be-card-header h3 {
  color: #ffffff;
}

[data-theme="dark"] .filtros-rapidos select {
  background: var(--bg-subtle);
  color: #ffffff;
  border-color: var(--border);
}

[data-theme="dark"] .btn-link-action {
  color: #60a5fa;
}

[data-theme="dark"] .btn-link-action:hover {
  color: #93c5fd;
}

/* Modal Actions Buttons styling (cancel/save) */
.modal-actions button {
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: var(--transition);
  min-width: 120px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  border: none;
}

.modal-actions .btn-secondary {
  background: #ffffff;
  color: var(--text-secondary);
  border: 1.5px solid var(--border);
}

.modal-actions .btn-secondary:hover {
  background: var(--gray-50);
  border-color: var(--gray-300);
}

.modal-actions .btn-primary {
  background: var(--primary);
  color: #ffffff;
  box-shadow: 0 1px 3px rgba(30, 58, 95, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.modal-actions .btn-primary:hover:not(:disabled) {
  background: var(--primary-dark);
}

/* Dark mode for modal buttons */
[data-theme="dark"] .modal-actions .btn-secondary {
  background: var(--bg-card);
  color: #ffffff;
  border-color: var(--border);
}

[data-theme="dark"] .modal-actions .btn-secondary:hover {
  background: var(--bg-subtle);
  border-color: var(--border);
}

[data-theme="dark"] .modal-actions .btn-primary {
  background: #2563eb;
  color: #ffffff;
}

[data-theme="dark"] .modal-actions .btn-primary:hover:not(:disabled) {
  background: #1d4ed8;
}

/* Password Modal Username text readability in Dark Mode */
[data-theme="dark"] .password-user-info {
  background: var(--bg-subtle);
  color: #ffffff;
  border-color: var(--border);
}

/* Audit Log Expanded Row & Snapshot Diff Styling */
.audit-expand-cell {
  background-color: var(--gray-50) !important;
  padding: 16px !important;
}

.audit-expand-card {
  padding: 16px 20px;
  border-left: 4px solid var(--primary);
  background-color: #ffffff;
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}

.audit-expand-title {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--primary);
}

/* Diff Table */
.diff-container {
  overflow-x: auto;
  margin-top: 8px;
}

.diff-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  text-align: left;
}

.diff-table th {
  padding: 10px 14px;
  font-weight: 600;
  text-align: center;
  background-color: var(--gray-100);
  color: var(--gray-800);
  border-bottom: 2px solid var(--border);
}

.diff-table td {
  padding: 10px 14px;
  border-bottom: 1px solid var(--border-light);
}

.diff-field {
  font-weight: 600;
  color: var(--gray-700);
  font-family: var(--font-mono), monospace;
}

/* Dark Mode Overrides for Expanded Audit Row & Snapshot Diff Table */
[data-theme="dark"] .audit-expand-cell {
  background-color: var(--bg-subtle) !important;
}

[data-theme="dark"] .audit-expand-card {
  background-color: var(--bg-card);
  border-left: 4px solid #3b82f6;
  border: 1px solid var(--border);
  border-left-width: 4px;
}

[data-theme="dark"] .audit-expand-title {
  color: #60a5fa;
}

[data-theme="dark"] .diff-table th {
  background-color: var(--bg-subtle);
  color: #ffffff;
  border-bottom: 2px solid var(--border);
}

[data-theme="dark"] .diff-field {
  color: #e2e8f0;
}

/* Compact styling for the Audit Log Table */
.audit-table th,
.audit-table td {
  padding: 10px 12px !important;
  font-size: 13px !important;
}

.audit-table thead th {
  font-weight: 700;
  letter-spacing: 0.4px;
  text-align: center;
}

/* Ensure specific width and no wrap where necessary */
.audit-table td:nth-child(1) { /* Fecha */
  white-space: nowrap;
  width: 150px;
}

.audit-table td:nth-child(2) { /* Ticket */
  white-space: nowrap;
  width: 130px;
}

.audit-table td:nth-child(4) { /* Rol */
  white-space: nowrap;
}

.audit-table td:nth-child(8) { /* IP Cliente */
  white-space: nowrap;
  width: 100px;
}

.audit-table td:nth-child(10) { /* Cambios button */
  white-space: nowrap;
  text-align: center;
  width: 100px;
}

/* Row expand styling */
.audit-expand-row {
  border-bottom: 1px solid var(--border-light);
}

[data-theme="dark"] .audit-table tbody tr:hover {
  background: rgba(255, 255, 255, 0.02) !important;
}

/* ─── Toggle Switch para Sede Central ─── */
.toggle-group {
  display: flex;
  flex-direction: row !important; /* Forza fila para evitar heredar el column de .form-group */
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  padding: 0.5rem 0;
}

.toggle-container {
  position: relative;
  width: 48px;
  height: 24px;
}

.toggle-container input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: var(--bg-hover, rgba(255,255,255,0.1));
  transition: .3s;
  border-radius: 24px;
  border: 1px solid var(--border-color, rgba(255,255,255,0.2));
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  bottom: 2px;
  background-color: var(--text-muted, #94a3b8);
  transition: .3s;
  border-radius: 50%;
}

.toggle-container input:checked + .toggle-slider {
  background-color: var(--color-primary, #6366f1);
  border-color: var(--color-primary, #6366f1);
}

.toggle-container input:checked + .toggle-slider:before {
  transform: translateX(24px);
  background-color: #fff;
}

.toggle-label-info {
  display: flex;
  flex-direction: column;
}

.toggle-label-info strong {
  font-size: 0.95rem;
  color: #000; /* Negro en modo claro, como lo solicitó el usuario */
}

.toggle-label-info p {
  font-size: 0.8rem;
  color: #64748b;
  margin: 0;
}

[data-theme="dark"] .toggle-label-info strong {
  color: #f8fafc;
}

[data-theme="dark"] .toggle-label-info p {
  color: #94a3b8;
}


`, "",{"version":3,"sources":["webpack://./src/pages/AdminDashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+DAA+D;EAC/D,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,eAAe;EACf,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,4BAA4B;EAC5B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;EAC/B,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,8DAA8D;EAC9D,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,2CAA2C;AAC3C;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,0EAA0E;AAC5E;;AAEA;EACE,+BAA+B;AACjC;;AAEA,gCAAgC;AAChC;EACE,0BAA0B;EAC1B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,4BAA4B;EAC5B,cAAc;EACd,2BAA2B;AAC7B;;AAEA,mDAAmD;AACnD;EACE,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,qEAAqE;AACrE;EACE,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;;EAEE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD,+BAA+B,UAAU;EACvC,mBAAmB;EACnB,YAAY;AACd;;AAEA,+BAA+B,WAAW;EACxC,mBAAmB;EACnB,YAAY;AACd;;AAEA,+BAA+B,QAAQ;EACrC,mBAAmB;AACrB;;AAEA,+BAA+B,eAAe;EAC5C,mBAAmB;EACnB,YAAY;AACd;;AAEA,gCAAgC,mBAAmB;EACjD,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,4CAA4C;AAC9C;;AAEA;EACE,gDAAgD;AAClD;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B,EAAE,4DAA4D;EAC5F,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,wDAAwD;EACxD,eAAe;EACf,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,4CAA4C;EAC5C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,qDAAqD;AACpE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".admin-dashboard {\n  max-width: 1800px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 24px;\n  animation: fadeInUp 0.5s ease;\n}\n\n.admin-header {\n  margin-bottom: 24px;\n}\n\n.admin-header h2 {\n  margin-bottom: 16px;\n  color: var(--text);\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n}\n\n.admin-tabs {\n  display: flex;\n  gap: 4px;\n  background: var(--bg-card);\n  padding: 4px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n  overflow-x: auto;\n}\n\n.tab-btn {\n  flex: 1;\n  min-width: 110px;\n  padding: 10px 16px;\n  background: none;\n  border: none;\n  border-radius: var(--radius);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-muted);\n  transition: var(--transition);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.tab-btn:hover {\n  color: var(--primary);\n  background: var(--primary-ultralight);\n}\n\n.tab-btn.active {\n  color: var(--primary);\n  background: var(--primary-ultralight);\n  font-weight: 600;\n  box-shadow: var(--shadow-xs);\n}\n\n.tab-icon {\n  font-size: 16px;\n  transition: var(--transition);\n}\n\n.tab-btn:hover .tab-icon,\n.tab-btn.active .tab-icon {\n  transform: scale(1.1);\n}\n\n.tab-content {\n  animation: fadeInUp 0.4s ease;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border);\n}\n\n.section-header h3 {\n  color: var(--gray-900);\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.filtros-rapidos {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.filtros-rapidos select {\n  padding: 10px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 14px;\n  background: var(--white);\n  transition: var(--transition);\n  font-family: var(--font-sans);\n  cursor: pointer;\n}\n\n.filtros-rapidos select:hover {\n  border-color: var(--gray-400);\n}\n\n.filtros-rapidos select:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n  transform: translateY(-1px);\n}\n\n/* Filtros */\n.filtros-container {\n  background: var(--bg-card);\n  padding: 24px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 24px;\n  border: 1px solid var(--border);\n}\n\n.filtros-container h3 {\n  margin-bottom: 20px;\n  color: var(--gray-900);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.filtros-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.filtros-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n/* Por estado */\n.por-estado {\n  background: var(--bg-card);\n  padding: 24px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 24px;\n  border: 1px solid var(--border);\n}\n\n.por-estado h3 {\n  margin-bottom: 20px;\n  color: var(--gray-900);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.estados-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.estado-card {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px;\n  background: var(--gray-50);\n  border-radius: var(--radius);\n  transition: var(--transition);\n  border: 1px solid transparent;\n}\n\n.estado-card:hover {\n  background: var(--white);\n  border-color: var(--border);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-sm);\n}\n\n.estado-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  animation: pulse 2s ease infinite;\n}\n\n.estado-label {\n  flex: 1;\n  font-size: 13px;\n  color: var(--gray-700);\n  font-weight: 500;\n}\n\n.estado-count {\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--primary);\n}\n\n/* Tabla container */\n.tabla-container {\n  background: var(--bg-card);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  border: 1px solid var(--border);\n  transition: var(--transition);\n}\n\n.tabla-container:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.tabla-container h3 {\n  margin: 0;\n  padding: 16px 20px;\n  color: var(--gray-800);\n  font-size: 16px;\n  font-weight: 600;\n  border-bottom: 1px solid var(--border);\n  background: var(--gray-50);\n}\n\n/* Acciones celda */\n.acciones-celda {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* Áreas Grid */\n.areas-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n}\n\n.area-card {\n  background: var(--bg-card);\n  padding: 24px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  transition: var(--transition);\n  border: 1px solid var(--border);\n  position: relative;\n  overflow: hidden;\n  animation: fadeInUp 0.4s ease;\n  animation-fill-mode: both;\n}\n\n.area-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, var(--primary), var(--info));\n  transition: var(--transition);\n}\n\n.area-card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-4px);\n  border-color: var(--gray-200);\n}\n\n.area-card:hover::before {\n  height: 6px;\n}\n\n.area-card.inactiva {\n  opacity: 0.6;\n}\n\n.area-card.inactiva::before {\n  background: var(--gray-400);\n}\n\n.area-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.area-header h4 {\n  margin: 0;\n  color: var(--gray-900);\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.area-desc {\n  color: var(--text-muted);\n  font-size: 14px;\n  margin-bottom: 16px;\n  line-height: 1.6;\n}\n\n.area-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n}\n\n.area-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* Configuración */\n.config-container {\n  background: var(--bg-card);\n  padding: 28px;\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n}\n\n.config-section {\n  margin-bottom: 28px;\n  padding-bottom: 28px;\n  border-bottom: 1px solid var(--border);\n}\n\n.config-section:last-of-type {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.config-section h4 {\n  margin-bottom: 20px;\n  color: var(--gray-900);\n  font-size: 18px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.config-section .form-group label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.config-section input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--primary);\n  transition: var(--transition);\n}\n\n.config-section input[type=\"time\"],\n.config-section input[type=\"number\"],\n.config-section input[type=\"text\"],\n.config-section textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 14px;\n  transition: var(--transition);\n  background: var(--white);\n  font-family: var(--font-sans);\n}\n\n.config-section input[type=\"time\"]:hover,\n.config-section input[type=\"number\"]:hover,\n.config-section input[type=\"text\"]:hover,\n.config-section textarea:hover {\n  border-color: var(--gray-400);\n}\n\n.config-section input:focus,\n.config-section textarea:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px var(--primary-light);\n  transform: translateY(-1px);\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 28px;\n  padding-top: 24px;\n  border-top: 1px solid var(--border);\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(8px);\n  animation: fadeIn 0.2s ease;\n}\n\n.modal-content {\n  background: var(--bg-card);\n  padding: 28px;\n  border-radius: var(--radius-lg);\n  width: 90%;\n  max-width: 520px;\n  box-shadow: var(--shadow-xl);\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: modalSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n  border: 1px solid var(--border);\n}\n\n.modal-content.modal-lg {\n  max-width: 720px;\n}\n\n.modal-content h3 {\n  margin-bottom: 20px;\n  color: var(--gray-900);\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.modal-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n/* Password button */\n.btn-password {\n  background: var(--purple-light);\n  color: var(--purple);\n  border: 1px solid var(--purple);\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 14px;\n  transition: var(--transition);\n}\n\n.btn-password:hover {\n  background: var(--purple);\n  color: var(--white);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);\n}\n\n/* Password modal */\n.password-user-info {\n  color: var(--text-muted);\n  font-size: 14px;\n  margin-bottom: 20px;\n  padding: 12px 16px;\n  background: var(--gray-50);\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .admin-header h2 {\n    font-size: 24px;\n  }\n\n  .admin-tabs {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .tab-btn {\n    justify-content: flex-start;\n    min-width: auto;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .filtros-rapidos {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .filtros-rapidos select {\n    width: 100%;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .areas-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .estados-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .acciones-celda {\n    flex-direction: column;\n  }\n\n  .acciones-celda .btn-small {\n    width: 100%;\n    text-align: center;\n  }\n  \n  .modal-actions {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .modal-actions button {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-header h2 {\n    font-size: 20px;\n  }\n\n  .tab-btn {\n    padding: 10px 14px;\n    font-size: 13px;\n  }\n\n  .tab-icon {\n    font-size: 16px;\n  }\n\n  .config-container {\n    padding: 20px;\n  }\n\n  .modal-content {\n    padding: 20px;\n  }\n}\n\n/* Dark mode overrides for AdminDashboard */\n[data-theme=\"dark\"] .admin-header h2 {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .admin-tabs {\n  background: var(--bg-card);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .tab-btn {\n  color: var(--text-muted);\n}\n\n[data-theme=\"dark\"] .tab-btn:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n[data-theme=\"dark\"] .tab-btn.active {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: none;\n}\n\n[data-theme=\"dark\"] .section-header h3,\n[data-theme=\"dark\"] .filtros-container h3,\n[data-theme=\"dark\"] .por-estado h3,\n[data-theme=\"dark\"] .area-header h4,\n[data-theme=\"dark\"] .config-section h4,\n[data-theme=\"dark\"] .modal-content h3 {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .estado-label {\n  color: var(--text-secondary);\n}\n\n[data-theme=\"dark\"] .estado-count {\n  color: #60a5fa;\n}\n\n[data-theme=\"dark\"] .estado-card {\n  background: var(--bg-card);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .estado-card:hover {\n  background: var(--bg-subtle);\n  border-color: var(--border);\n  box-shadow: none;\n}\n\n[data-theme=\"dark\"] .tabla-container h3 {\n  color: #ffffff;\n  background: var(--bg-subtle);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .role-badge {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .bandeja-entrada-titulo {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .be-card-header h3 {\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .filtros-rapidos select {\n  background: var(--bg-subtle);\n  color: #ffffff;\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .btn-link-action {\n  color: #60a5fa;\n}\n\n[data-theme=\"dark\"] .btn-link-action:hover {\n  color: #93c5fd;\n}\n\n/* Modal Actions Buttons styling (cancel/save) */\n.modal-actions button {\n  padding: 10px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: var(--transition);\n  min-width: 120px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 42px;\n  border: none;\n}\n\n.modal-actions .btn-secondary {\n  background: #ffffff;\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border);\n}\n\n.modal-actions .btn-secondary:hover {\n  background: var(--gray-50);\n  border-color: var(--gray-300);\n}\n\n.modal-actions .btn-primary {\n  background: var(--primary);\n  color: #ffffff;\n  box-shadow: 0 1px 3px rgba(30, 58, 95, 0.2), 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.modal-actions .btn-primary:hover:not(:disabled) {\n  background: var(--primary-dark);\n}\n\n/* Dark mode for modal buttons */\n[data-theme=\"dark\"] .modal-actions .btn-secondary {\n  background: var(--bg-card);\n  color: #ffffff;\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .modal-actions .btn-secondary:hover {\n  background: var(--bg-subtle);\n  border-color: var(--border);\n}\n\n[data-theme=\"dark\"] .modal-actions .btn-primary {\n  background: #2563eb;\n  color: #ffffff;\n}\n\n[data-theme=\"dark\"] .modal-actions .btn-primary:hover:not(:disabled) {\n  background: #1d4ed8;\n}\n\n/* Password Modal Username text readability in Dark Mode */\n[data-theme=\"dark\"] .password-user-info {\n  background: var(--bg-subtle);\n  color: #ffffff;\n  border-color: var(--border);\n}\n\n/* Audit Log Expanded Row & Snapshot Diff Styling */\n.audit-expand-cell {\n  background-color: var(--gray-50) !important;\n  padding: 16px !important;\n}\n\n.audit-expand-card {\n  padding: 16px 20px;\n  border-left: 4px solid var(--primary);\n  background-color: #ffffff;\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n\n.audit-expand-title {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n/* Diff Table */\n.diff-container {\n  overflow-x: auto;\n  margin-top: 8px;\n}\n\n.diff-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  text-align: left;\n}\n\n.diff-table th {\n  padding: 10px 14px;\n  font-weight: 600;\n  text-align: center;\n  background-color: var(--gray-100);\n  color: var(--gray-800);\n  border-bottom: 2px solid var(--border);\n}\n\n.diff-table td {\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.diff-field {\n  font-weight: 600;\n  color: var(--gray-700);\n  font-family: var(--font-mono), monospace;\n}\n\n/* Dark Mode Overrides for Expanded Audit Row & Snapshot Diff Table */\n[data-theme=\"dark\"] .audit-expand-cell {\n  background-color: var(--bg-subtle) !important;\n}\n\n[data-theme=\"dark\"] .audit-expand-card {\n  background-color: var(--bg-card);\n  border-left: 4px solid #3b82f6;\n  border: 1px solid var(--border);\n  border-left-width: 4px;\n}\n\n[data-theme=\"dark\"] .audit-expand-title {\n  color: #60a5fa;\n}\n\n[data-theme=\"dark\"] .diff-table th {\n  background-color: var(--bg-subtle);\n  color: #ffffff;\n  border-bottom: 2px solid var(--border);\n}\n\n[data-theme=\"dark\"] .diff-field {\n  color: #e2e8f0;\n}\n\n/* Compact styling for the Audit Log Table */\n.audit-table th,\n.audit-table td {\n  padding: 10px 12px !important;\n  font-size: 13px !important;\n}\n\n.audit-table thead th {\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-align: center;\n}\n\n/* Ensure specific width and no wrap where necessary */\n.audit-table td:nth-child(1) { /* Fecha */\n  white-space: nowrap;\n  width: 150px;\n}\n\n.audit-table td:nth-child(2) { /* Ticket */\n  white-space: nowrap;\n  width: 130px;\n}\n\n.audit-table td:nth-child(4) { /* Rol */\n  white-space: nowrap;\n}\n\n.audit-table td:nth-child(8) { /* IP Cliente */\n  white-space: nowrap;\n  width: 100px;\n}\n\n.audit-table td:nth-child(10) { /* Cambios button */\n  white-space: nowrap;\n  text-align: center;\n  width: 100px;\n}\n\n/* Row expand styling */\n.audit-expand-row {\n  border-bottom: 1px solid var(--border-light);\n}\n\n[data-theme=\"dark\"] .audit-table tbody tr:hover {\n  background: rgba(255, 255, 255, 0.02) !important;\n}\n\n/* ─── Toggle Switch para Sede Central ─── */\n.toggle-group {\n  display: flex;\n  flex-direction: row !important; /* Forza fila para evitar heredar el column de .form-group */\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n  padding: 0.5rem 0;\n}\n\n.toggle-container {\n  position: relative;\n  width: 48px;\n  height: 24px;\n}\n\n.toggle-container input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: var(--bg-hover, rgba(255,255,255,0.1));\n  transition: .3s;\n  border-radius: 24px;\n  border: 1px solid var(--border-color, rgba(255,255,255,0.2));\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 2px;\n  bottom: 2px;\n  background-color: var(--text-muted, #94a3b8);\n  transition: .3s;\n  border-radius: 50%;\n}\n\n.toggle-container input:checked + .toggle-slider {\n  background-color: var(--color-primary, #6366f1);\n  border-color: var(--color-primary, #6366f1);\n}\n\n.toggle-container input:checked + .toggle-slider:before {\n  transform: translateX(24px);\n  background-color: #fff;\n}\n\n.toggle-label-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.toggle-label-info strong {\n  font-size: 0.95rem;\n  color: #000; /* Negro en modo claro, como lo solicitó el usuario */\n}\n\n.toggle-label-info p {\n  font-size: 0.8rem;\n  color: #64748b;\n  margin: 0;\n}\n\n[data-theme=\"dark\"] .toggle-label-info strong {\n  color: #f8fafc;\n}\n\n[data-theme=\"dark\"] .toggle-label-info p {\n  color: #94a3b8;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
